export const IGNORE_LIST_API_URL_MAP: { [key: string]: string } = {
  emails: "email",
  individuals: "individual",
  locations: "location",
  nationalInsurances: "national-insurance",
  phones: "phone",
  vehicles: "vehicle",
  vehicleCreditHireClientIds: "vehicle-credit-hire",
} as const;

export const ENTITY_TYPE_MAP: { [key: string]: string } = {
  EMAILS: "emails",
  INDIVIDUALS: "individuals",
  LOCATIONS: "locations",
  NATIONAL_INSURANCES: "nationalInsurances",
  PHONES: "phones",
  VEHICLES: "vehicles",
  VEHICLE_CREDIT_HIRE_CLIENT_IDS: "vehicleCreditHireClientIds",
} as const;
